Ext.ns('mx.Util');

mx.Util.ServerEvents = {
    OnlyOneListenerException: function(channel) {
        return (
            'ChannelForSingleListenerException\n' +
            'Only one listener can be used on this channel.\n' +
            "Channel: '" +
            channel +
            "'"
        );
    },
    bindings: {},
    prepareChannel: function(channel) {
        // leading and trailing slashes are optional
        channel = channel.startsWith('/') ? channel : '/' + channel;
        channel = channel.endsWith('/') ? channel : channel + '/';
        this.bindings[channel] = this.bindings[channel] || [];
        return channel;
    },
    bind: function(/*String /[server|client]/channel/type/*/ channel, /*function (data, channel)*/ listener) {
        mx.Util.ServerEvents.serverSide.start();
        channel = this.prepareChannel(channel);
        if (this.bindings[channel].indexOf(listener) == -1) {
            this.bindings[channel].push(listener);
        }
    },
    unbind: function(channel, listener) {
        channel = this.prepareChannel(channel);
        var i = this.bindings[channel].indexOf(listener);
        if (i != -1) {
            this.bindings[channel].splice(i, 1);
        }
        if (!this.bindings.length) {
            mx.Util.ServerEvents.serverSide.stop();
        }
    },
    trigger: function(channel, data) {
        channel = this.prepareChannel(channel);
        this.bindings[channel].forEach(function(listener) {
            listener.apply(data, [data, channel]);
        });
    },
    bindSingle: function(channel, listener) {
        mx.Util.ServerEvents.serverSide.start();
        channel = this.prepareChannel(channel);
        if (this.bindings[channel].length == 0) {
            this.bindings[channel].push(listener);
        } else {
            throw new this.OnlyOneListenerException(channel);
        }
    },
    triggerSingle: function(channel, data) {
        channel = this.prepareChannel(channel);
        return this.bindings[channel][0].apply(data, [data, channel]);
    },
    serverSide: (function() {
        var timerHandle = null;
        var requestedEvents = false;
        var started = false;
        var stopCallback = {};
        var currentThreadId = 0;
        var toConfirm = [];
        var toDefer = [];
        var timings = {
            pull: 1000, // was: 10000
            timeout: 30000,
            afterError: 10000, //5000 in fast mode
        };

        function pullEvents() {
            if (requestedEvents && !stopCallback) {
                console.log('dont call events');
                return;
            }
            requestedEvents = true;
            var params = {};
            if (toConfirm.length) {
                params['confirmedIds'] = toConfirm;
            }
            if (toDefer.length) {
                params['deferredIds'] = toDefer;
            }
            var id = (currentThreadId = Math.random());
            stopCallback[id] = false;
            //            console.log("create request " + id);
            mx.data.Ajax.request({
                url: mx.PATH + MXAT.API('event/'),
                method: 'GET',
                timeout: timings.timeout,
                headers: {
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache, must-revalidate',
                    //Expires: (some date in the past in the proper format)
                },
                params: params,
                success: function(response) {
                    if (stopCallback[id]) {
                        //                        console.log("stop callback " + id);
                        delete stopCallback[id];
                        return;
                    }
                    delete stopCallback[id];
                    requestedEvents = false;
                    //decode response
                    var decoded = Ext.util.JSON.decode(response.responseText);
                    if (decoded) {
                        if (decoded.errors.length) {
                            console.log('Events error status: ' + response.statusText + ', ' + response.status);
                            setupPullEvents(true);
                            return;
                        }
                        var eventsList = decoded.rows[0];
                        onEventsReceived(eventsList);
                    }
                },
                failure: function(response) {
                    requestedEvents = false;
                    console.log('Events error status: ' + response.statusText + ', ' + response.status);
                    setupPullEvents(true);
                },
                scope: this,
            });
        }

        function setupPullEvents(afterError) {
            if (started) {
                timerHandle = window.setTimeout(pullEvents, afterError ? timings.afterError : timings.pull);
            }
        }

        function onEventsReceived(eventsList) {
            if (eventsList.confirmed && eventsList.confirmed.length) {
                for (var i in eventsList.confirmed) {
                    var j = toConfirm.indexOf(eventsList.confirmed[i]);
                    if (j != -1) {
                        toConfirm.splice(j, 1);
                    }
                }
            }
            processEvents(eventsList.events);
            setupPullEvents();
        }

        function processEvents(events) {
            var eventPacketSizes = {};
            var eventPacketIndices = {};
            for (var i = 0; i < events.length; ++i) {
                var type = events[i]['type'];
                eventPacketSizes[type] = (eventPacketSizes[type] ? eventPacketSizes[type] : 0) + 1;
                eventPacketIndices[type] = 0;
            }
            for (var i = 0; i < events.length; ++i) {
                var event = events[i];
                event.isLastInPacket = eventPacketSizes[event['type']] == ++eventPacketIndices[event['type']];
                event['body'] = Ext.util.JSON.decode(event['value']);
                event['channel'] = '/server/' + event['type'].toLowerCase();
                try {
                    mx.Util.ServerEvents.trigger(event['channel'], event);
                } catch (e) {
                    console.error(e.message + ' Event executing with error (id: ' + event.id + ')');
                }
            }
        }

        return {
            start: function() {
                if (!started) {
                    started = true;
                    setupPullEvents();
                }
            },
            stop: function() {
                started = false;
                if (timerHandle) {
                    clearTimeout(timerHandle);
                    timerHandle = null;
                }
            },
            confirm: function(eventId) {
                if (toConfirm.indexOf(eventId) == -1) {
                    toConfirm.push(eventId);
                }
            },
            defer: function(eventId) {
                if (toDefer.indexOf(eventId) == -1) {
                    toDefer.push(eventId);
                }
            },
            reset: function(eventId) {
                toDefer.length = 0;
                stopCallback[currentThreadId] = true;
                //                console.log("reset " + currentThreadId);
                requestedEvents = false;
                mx.Util.ServerEvents.serverSide.start();
            },
        };
    })(),
};

mx.Util.ServerEvents.confirm = mx.Util.ServerEvents.serverSide.confirm;
mx.Util.ServerEvents.defer = mx.Util.ServerEvents.serverSide.defer;
mx.Util.ServerEvents.reset = mx.Util.ServerEvents.serverSide.reset;
